export default "__VITE_ASSET__DL4VVX90__"